import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=1a13f2a9&scoped=true&"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a13f2a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
